import { Modules } from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'

class Section extends PureComponent {
  constructor(props) {
    super(props);

    this.renderWrapper = this.renderWrapper.bind(this);
  }

  renderModules() {
    const modules = _get(this.props, 'content.modules', [
      _get(this.props, 'content'),
    ]);
    return modules.map((module, i) => (
      <Modules
        key={`${module.id}_${i}`}
        {...{
          ...this.props,
          content: module,
        }}
      />
    ));
  }

  renderWrapper() {
    const { textColor, backgroundColor } = this.props;

    return (
      <SectionWrapper
        {...{
          textColor,
          backgroundColor,
        }}>
        {this.renderModules()}
      </SectionWrapper>
    );
  }

  render() {
    return this.renderWrapper();
  }
}

const SectionWrapper = styled.div`
    color: ${props => props.textColor};
    background-color: ${props => props.backgroundColor || '#fff'};
    position: relative;
    height: ${props => (props.hero ? '100vh' : '')};
`;

export default Section;

// let TextListItemCounter = 0;

// modules.map((component, i) => {
//     const listItemIndex = TextListItemCounter;
//     if (component.__typename == 'DatoCmsTextListItem') {
//         TextListItemCounter++;
//     }
//     return (
//         <Components
//             textColor={component.hex}
//             navigateWithTransition={navigateWithTransition}
//             backgroundColor={component.hex}
//             listItemIndex={listItemIndex}
//             key={`${component.id} ${i}`}
//             content={component}
//             thoughts={this.props.thoughts}
//             cases={this.props.cases}
//         />
//     );
// })}
